angular.module('unica.basic_services')

.factory('statusInterceptor', function($rootScope, $state, Session, AUTH_EVENTS, $q) {

	var redirecting = false;
	return {
		response: function(response) {
			return response || $q.when(response);
		},

		responseError: function(rejection)
		{
			if (rejection.config.url.indexOf('/auth/me') !== -1)
			{
				return $q.reject(rejection);
			}
			if (!redirecting && (rejection.status === 401 || rejection.status === 403))
			{
				redirecting = true;
				$rootScope.setCurrentUser(null);
				$rootScope.isAuthorized = false;
				$rootScope.manageError(rejection.data);
				$rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
			}

			if ( rejection.status === 422 ) {

				$rootScope.manageError(rejection.data);

				if ( rejection.data.action && rejection.data.action === 'logout' ) {
					Session.destroy();
					window.location.href = '/nam/login';
					//$state.go('app.auth_login');
				}
			}
		}

	};

});
